// extracted by mini-css-extract-plugin
module.exports = {"indicator":"ScrollIndicator-module--indicator--2Sml6","bounce":"ScrollIndicator-module--bounce--rWNjI","hidden":"ScrollIndicator-module--hidden--3oMVQ"};